module.exports = {
	API_ENDPOINT: "https://api.eventupp.eu",
	IMG_ENDPOINT: "https://api.eventupp.eu",
	WEB_ENDPOINT: "https://eventupp.eu",
	MAX_ACCESS_LEVEL: 4,
};